import { Box, Tooltip, Typography } from "@mui/material";
import { MdEditDocument } from "react-icons/md";
import styles from "../InternalTracker.module.css";
import { allLocation } from "../../../redux/common/locationSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { Icon } from "@iconify/react/dist/iconify.js";

const CandidateListCard = ({
  candidate,
  handleShowAdd,
  setSubmisionRow,
  handleShowCandidate,
}) => {
  const locations = useSelector((state) => state.location) || [];
  const workautho = useSelector((state) => state.workautho);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, [dispatch]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const handleOnClickView = (candidate) => {
    setSubmisionRow(candidate);
    handleShowCandidate();
  };

  return (
    <Box className={styles.candidateListView}>
      <Box>
        <Typography>
          {candidate?.full_name}, {candidate?.current_job_title} (Exp{" "}
          {candidate?.total_experience}{" "}
          {candidate?.total_experience > 1 ? "Years" : "Year"})
        </Typography>
        <Typography>
          {getLocationById(candidate?.current_location)},{" "}
          {getPreferLocationNames(candidate?.prefer_location)}
        </Typography>
        <Typography>
          {getWorkAuthorization(candidate?.work_authorization)}
        </Typography>
        <Typography>
          {" "}
          {candidate?.p_tax_team?.includes("full_Time") ? "Salary" : "Rate"} $
          {candidate?.rate}
          {candidate?.p_tax_team?.includes("full_Time")
            ? "K Yearly"
            : " Hourly"}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
        {/* <MdEditDocument style={{ fontSize: "26px", margin: "0 10px 15px 0" }} /> */}
        <a
          className={styles.phase2}
          href={candidate?.resume}
          target="_blank"
          style={{ textDecoration: "none", color: "#374151" }}
        >
          <Box
            sx={{
              backgroundColor: "#e4e6eb",
              padding: "4px",
              borderRadius: "3px",
              margin: "0 10px 15px 0",
            }}
          >
            <Tooltip title="Download Resume" arrow>
              <Icon icon="pepicons-pencil:cv" height={30} width={30} />
            </Tooltip>
          </Box>
        </a>
        <span>
          <button
            onClick={() => handleShowAdd(candidate)}
            style={{ marginRight: "10px" }}
          >
            Add to Job
          </button>
          <button onClick={() => handleOnClickView(candidate)}>
            View Details
          </button>
        </span>
      </Box>
    </Box>
  );
};

export default CandidateListCard;
